export const EXPRESS_INVOICE_JOURNAL_ENTRY_MODE_MESSAGE =
    "Accounts created by Kick always generate journal entries";
